












































































































































import Vue from "vue";
import Modal from "@/components/Modal/Modal.vue";
import { store } from "@/store/store";
import { Agence } from "@/store/modules/Agence/interface";
import { ApiResponse, FormType } from "@/types/types";
import { Category } from "@/store/modules/Category/interface";
import { State } from "@/store/modules/State/interface";
import { DeviceActionsTypes } from "@/store/modules/Device/types";
import { User } from "@/store/modules/User/interface";
import { Response_ } from "@/plugins/axios/response";
import Utils from "@/utils/utils";
import { CameraResolution } from "@/store/modules/CameraResolution/interface";

export default Vue.extend({
  name: "DeviceCreateModal",
  components: { Modal },
  props: {
    should_display: {
      type: Boolean,
      default: false
    },
    onClose: {
      type: Function,
      default: () => undefined
    },
    onValidate: {
      type: Function,
      default: () => undefined
    },
    device: {
      type: Object
    },
    onAction: {
      type: Function,
      default: () => undefined
    }
  },
  data() {
    return {
      form: this.$props.device
        ? this.$props.device
        : {
            material_name: "",
            agence: "",
            state: "",
            category: "",
            version_os: "",
            version_ihm: "",
            sd: "",
            infrared: false,
            resolution: null
          },
      loading: false,
      type: this.$props.device ? FormType.UPDATE : FormType.CREATE
    };
  },
  methods: {
    onInputChange(value: string, type: string): void {
      if (type === "infrared") {
        Utils.transformStringBoolean(value);
      }
      this.form[type] = value || "";
    },
    displayButtonName(): string {
      return this.type === FormType.UPDATE ? "Modifier" : "Créer";
    },
    validateDeviceName(name: string): boolean {
      return String(name).match(/[A-Z|0-9]{2,6}[_-][0-9]{2,4}$/) === null ? false : true;
    },
    async validate(): Promise<void> {
      this.loading = true;
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        const request_result =
          this.type === FormType.CREATE
            ? await this.createDevice(this.form)
            : /* this.isAdmin
            ? await this.updateAdminDevice(
                {
                  _id: this.form._id,
                  state: this.form.state,
                  category: this.form.category,
                  agence: this.form.agence
                },
                this.$props?.device?._id
              )
            : */ await this.updateDevice(
                {
                  _id: this.form._id,
                  state: this.form.state,
                  category: this.form.category,
                  agence: this.form.agence
                },
                this.$props?.device?._id
              );
        if (
          (request_result as Response_).status === ApiResponse.CREATED ||
          (request_result as Response_).status === ApiResponse.SUCCESS
        ) {
          this.onAction({
            type: "SUCCESS",
            title: (request_result as Response_).type,
            content: (request_result as Response_).message
          });
          this.loading = false;
          this.onClose();
          return;
        } else {
          this.onAction({
            type: "ERROR",
            title: "Erreur formulaire",
            content: (request_result as Response_).message
          });
        }
      }
      this.loading = false;
    },
    async createDevice(device_data: any): Promise<Response_> {
      return await store.dispatch(DeviceActionsTypes.CREATE_DEVICE, device_data);
    },
    async updateDevice(device_data: any, _id: string): Promise<Response_> {
      return await store.dispatch(DeviceActionsTypes.UPDATE_DEVICE, { device_data: device_data, _id: _id });
    },
    async updateAdminDevice(device_data: any, _id: string): Promise<Response_> {
      return await store.dispatch(DeviceActionsTypes.UPDATE_ADMIN_DEVICE, {
        device_data: device_data,
        _id: _id
      });
    }
  },
  computed: {
    title(): string {
      return this.type === FormType.CREATE ? "Créer un appareil" : `Modifier l'appareil ${this.form.material_name}`;
    },
    nameRules(): Array<(value: string) => boolean | string> {
      return [
        (value: string): boolean | string => value.length > 0 || `Le champ nom est obligatoire.`,
        (value: string): boolean | string =>
          this.validateDeviceName(value) || `Le nom du materiel n'a pas la bonne syntaxe. exemple : 'AB-123'`
      ];
    },
    agenceRules(): Array<(value: string) => boolean | string> {
      return [
        (value: string): boolean | string => value.length > 0 || `Le champ agence est obligatoire.`,
        (value: string): boolean | string =>
          this.agences.find((agence: Agence) => agence._id === value) === undefined
            ? `La valeur renseignée n'est pas valide`
            : true
      ];
    },
    stateRules(): Array<(value: string) => boolean | string> {
      return [
        (value: string): boolean | string => value.length > 0 || `Le champ êtat est obligatoire.`,
        (value: string): boolean | string =>
          this.states.find((state: State) => state._id === value) === undefined
            ? `La valeur renseignée n'est pas valide`
            : true
      ];
    },
    categoryRules(): Array<(value: string) => boolean | string> {
      return [
        (value: string): boolean | string => value.length > 0 || `Le champ êtat est obligatoire.`,
        (value: string): boolean | string =>
          this.categories.find((category: Category) => category._id === value) === undefined
            ? `La valeur renseignée n'est pas valide`
            : true
      ];
    },
    infraredRules(): Array<(value: string) => boolean | string> {
      return [
        (value: string): boolean | string => (value !== "" && value !== null) || `Le champ Infrarouge est obligatoire.`
      ];
    },
    agences(): Array<Agence> {
      //const logged_user = store.getters.LOGGED_USER;
      return store.getters.AGENCE_ALL_ID.map(
        (agence) => store.getters.AGENCE_BY_ID[agence]
      ); /* store.getters.ROLE_BY_ID[logged_user?.role as string].name.toUpperCase() === UserRole.ADMINISTRATOR
        ? store.getters.AGENCE_ALL_ID.map((agence) => store.getters.AGENCE_BY_ID[agence])
        : [store.getters.AGENCE_BY_ID[logged_user?.agence as string]]; */
    },
    categories(): Array<Category> {
      return store.getters.CATEGORY_ALL_ID.map((category) => store.getters.CATEGORY_BY_ID[category]);
    },
    states(): Array<State> {
      return store.getters.STATE_ALL_ID.map((state) => store.getters.STATE_BY_ID[state]);
    },
    resolution(): Array<CameraResolution> {
      return store.getters.CAMERA_RESOLUTION_ALL_ID.map(
        (resolution) => store.getters.CAMERA_RESOLUTION_BY_ID[resolution]
      );
    },
    isAdmin(): boolean {
      const user = store.getters.LOGGED_USER as User;
      return store.getters.ROLE_BY_ID[user.role].name.toUpperCase() === "ADMIN" ? true : false;
    }
  }
});
